import { gql } from '../../../apollo/__generated__';

export const ADD_BEDROOM_TO_PLACE = gql(`
  mutation AddBedroomToPlace($addBedroomToPlaceInput: AddBedroomToPlaceInput!) {
    addBedroomToPlace(addBedroomToPlaceInput: $addBedroomToPlaceInput) {
      id
      name
      address
      bedrooms {
        id
        floor
        doorNumber
        maxUsers
      }
    }
  }
`);
